export function cta_trial_locale() {
	var links = document.getElementsByTagName('a');

	if (links.length > 0) {
		for (var i = 0; i < links.length; i++) {
			if (links[i].href.includes('my.jurnal.id/id/users/sign_up') || links[i].href.includes('my.jurnal.id/en/users/sign_up')) {
				var url = new URL(links[i].href);
				// Deteksi bahasa dari <html lang="...">
				var htmlLang = (document.documentElement.lang || '').toLowerCase();
				var isEn = htmlLang.includes('en') || htmlLang.includes('us');
				var localeVal = isEn ? 'en' : 'id';

				if (!url.searchParams.has('locale')) {
					url.searchParams.set('locale', localeVal);
				}

				links[i].setAttribute('href', url.toString());
			}
		}
	}
}